/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchGroupStatus } from './MatchGroupStatus';
import {
    MatchGroupStatusFromJSON,
    MatchGroupStatusFromJSONTyped,
    MatchGroupStatusToJSON,
    MatchGroupStatusToJSONTyped,
} from './MatchGroupStatus';
import type { LineItemDetail } from './LineItemDetail';
import {
    LineItemDetailFromJSON,
    LineItemDetailFromJSONTyped,
    LineItemDetailToJSON,
    LineItemDetailToJSONTyped,
} from './LineItemDetail';

/**
 * A group of matched line items between insurer and contractor estimates
 * @export
 * @interface LineItemMatchGroup
 */
export interface LineItemMatchGroup {
    /**
     * Unique line item match group ID
     * @type {number}
     * @memberof LineItemMatchGroup
     */
    readonly id: number;
    /**
     * ID of the parent comparison
     * @type {number}
     * @memberof LineItemMatchGroup
     */
    comparisonId: number;
    /**
     * ID of the parent room match group (if this match is within a room)
     * @type {number}
     * @memberof LineItemMatchGroup
     */
    roomMatchGroupId?: number | null;
    /**
     * 
     * @type {MatchGroupStatus}
     * @memberof LineItemMatchGroup
     */
    status: MatchGroupStatus;
    /**
     * AI confidence score for this match group
     * @type {number}
     * @memberof LineItemMatchGroup
     */
    confidence?: number | null;
    /**
     * Notes about this match (AI reasoning or user notes)
     * @type {string}
     * @memberof LineItemMatchGroup
     */
    note?: string | null;
    /**
     * Matched line items from the insurer estimate
     * @type {Array<LineItemDetail>}
     * @memberof LineItemMatchGroup
     */
    insurerLineItems: Array<LineItemDetail>;
    /**
     * Matched line items from the contractor estimate
     * @type {Array<LineItemDetail>}
     * @memberof LineItemMatchGroup
     */
    contractorLineItems: Array<LineItemDetail>;
    /**
     * When the match group was created
     * @type {Date}
     * @memberof LineItemMatchGroup
     */
    createdAt: Date;
    /**
     * When the match group was last updated
     * @type {Date}
     * @memberof LineItemMatchGroup
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the LineItemMatchGroup interface.
 */
export function instanceOfLineItemMatchGroup(value: object): value is LineItemMatchGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('insurerLineItems' in value) || value['insurerLineItems'] === undefined) return false;
    if (!('contractorLineItems' in value) || value['contractorLineItems'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function LineItemMatchGroupFromJSON(json: any): LineItemMatchGroup {
    return LineItemMatchGroupFromJSONTyped(json, false);
}

export function LineItemMatchGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemMatchGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comparisonId': json['comparisonId'],
        'roomMatchGroupId': json['roomMatchGroupId'] == null ? undefined : json['roomMatchGroupId'],
        'status': MatchGroupStatusFromJSON(json['status']),
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'note': json['note'] == null ? undefined : json['note'],
        'insurerLineItems': ((json['insurerLineItems'] as Array<any>).map(LineItemDetailFromJSON)),
        'contractorLineItems': ((json['contractorLineItems'] as Array<any>).map(LineItemDetailFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function LineItemMatchGroupToJSON(json: any): LineItemMatchGroup {
    return LineItemMatchGroupToJSONTyped(json, false);
}

export function LineItemMatchGroupToJSONTyped(value?: Omit<LineItemMatchGroup, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'roomMatchGroupId': value['roomMatchGroupId'],
        'status': MatchGroupStatusToJSON(value['status']),
        'confidence': value['confidence'],
        'note': value['note'],
        'insurerLineItems': ((value['insurerLineItems'] as Array<any>).map(LineItemDetailToJSON)),
        'contractorLineItems': ((value['contractorLineItems'] as Array<any>).map(LineItemDetailToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

